export default "__VITE_ASSET__m2GfiDv4__"